import { Action, createReducer, on } from '@ngrx/store';
import { SharedState, initialState } from './state';
import {
  getAddedTodayPropertiesSuccess,
  getArisPrimeProperties,
  getArisPrimePropertiesFailure,
  getArisPrimePropertiesSuccess,
  getRecommendedPropertiesSuccess,
  setSharedData,
} from './actions';
const reducer = createReducer(
  initialState,
  on(
    getAddedTodayPropertiesSuccess,
    (state, { data }): SharedState => ({
      ...state,
      properties: data,
    })
  ),
  on(
    getArisPrimeProperties,
    (state): SharedState => ({
      ...state,
      primePropertiesLoading: true,
    })
  ),
  on(
    getArisPrimePropertiesSuccess,
    (state, { data }): SharedState => ({
      ...state,
      primeProperties: data,
      primePropertiesLoading: false,
    })
  ),
  on(
    getArisPrimePropertiesFailure,
    (state, { error }): SharedState => ({
      ...state,
      primePropertiesLoading: false,
      error,
    })
  ),
  on(
    getRecommendedPropertiesSuccess,
    (state, { data }): SharedState => ({
      ...state,
      recommendedProperties: data,
    })
  ),
  on(setSharedData, (state, { data }) => ({
    ...state,
    pagination: {
      pageNumber: data.pageNumber,
      pageSize: data.pageSize,
      totalPages: data.totalPages,
      totalRecords: data.totalRecords,
    },
  }))
);

export function SharedReducer(state: SharedState, action: Action) {
  return reducer(state, action);
}
